import * as React from 'react';

import { Spinner } from '@playbooks/ui/components/spinner';
import { cn } from '@playbooks/ui/lib/utils';

type LoadingStateProps = React.ComponentProps<'div'> & {
	title?: React.ReactNode;
	message?: React.ReactNode;
	variant?: 'section' | 'modal' | 'page';
};

function LoadingState({
	title = 'Loading',
	message = 'Give us a second...',
	variant = 'section',
	className,
	children,
	...props
}: LoadingStateProps) {
	// Theme
	const classNames = {
		root: cn(
			'flex items-center gap-4',
			variant === 'modal' && 'justify-center text-center',
			variant === 'page' && 'min-h-48',
			className,
		),
		spinner: variant === 'section' ? 'size-8' : 'size-12',
		content: cn('space-y-1', variant === 'modal' && 'text-center'),
	};

	// Render
	return (
		<div
			role='status'
			aria-live='polite'
			data-slot='loading-state'
			data-variant={variant}
			className={classNames.root}
			{...props}>
			<Spinner className={classNames.spinner} />
			<div className={classNames.content}>
				{title && <h3 className='type-heading'>{title}</h3>}
				{message && <p className='text-sm text-foreground-body'>{message}</p>}
				{children}
			</div>
		</div>
	);
}

export { LoadingState };
export type { LoadingStateProps };
